import * as React from "react";
import { ButtonProps, Button, Modal, Input, Label } from "semantic-ui-react";

interface AdditionalProps {
    promptText: string;
    headingText?: string;
    reasonPromptText?: string;
    onSubmit: (confirmationText: string) => void;
}

interface State {
    open: boolean;
    confirmAttempted: boolean;
    enteredConfirmationText: string;
}

export class ConfirmedReasonButton extends React.Component<ButtonProps & AdditionalProps, State> {
    public state = { open: false, confirmAttempted: false, enteredConfirmationText: "" };

    public render() {
        const { onClick, promptText, headingText, typeToConfirmText, reasonPromptText, ...buttonProps } = this.props;

        return (
            <div>
                <Button {...buttonProps} onClick={this.open} />
                <Modal size="mini" open={this.state.open}>
                    {this.props.headingText ?
                        <Modal.Header>
                            {this.props.headingText}
                        </Modal.Header>
                        : null
                    }
                    <Modal.Content>
                        <Modal.Description>
                            <p>{promptText}</p>
                            {reasonPromptText && <p>{reasonPromptText}</p>}
                        </Modal.Description>
                        <Input fluid onChange={(event, data) => this.setState({ enteredConfirmationText: data.value })} />
                        {!typeToConfirmText && this.state.confirmAttempted ?
                            <Label basic color="red" pointing>You must enter a reason!</Label> : null}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.close}>Cancel</Button>
                        <Button negative onClick={this.confirm}>Confirm</Button>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }

    private confirm = () => {
        this.setState({ confirmAttempted: true });
        if (this.state.enteredConfirmationText.length > 0) {
            this.props.onSubmit(this.state.enteredConfirmationText);
            this.close();
        }
    };

    private open = () => this.setState({ open: true, confirmAttempted: false, enteredConfirmationText: "" });
    private close = () => this.setState({ open: false, confirmAttempted: false, enteredConfirmationText: "" });
}
